import supabase from "../supabase";

/**
 * Helper to get the current user's org_id
 * Required for the messages table RLS policies
 */
const getCurrentOrgId = async (userId) => {
  if (!userId) return null;
  const { data } = await supabase
    .from("Users")
    .select("company_id")
    .eq("id", userId)
    .single();
  return data?.company_id || null;
};

/**
 * Sends a message/notification to a single user.
 */
export const sendNotification = async ({
  to_user,
  subject,
  body,
  type = "direct",
  article_id = null,
  project_id = null,
}) => {
  try {
    const { data: auth } = await supabase.auth.getUser();
    const from_user = auth?.user?.id;

    // ✅ FIX: Fetch org_id for RLS
    const org_id = await getCurrentOrgId(from_user);

    const { error } = await supabase.from("messages").insert({
      org_id, // ✅ Inserted here
      to_user,
      from_user,
      subject,
      body,
      type,
      article_id,
      project_id,
      status: "unread",
    });

    if (error) throw error;
  } catch (err) {
    console.error("Failed to send notification:", err);
  }
};

export const notifyTeam = async ({
  user_ids,
  subject,
  body,
  article_id,
  project_id,
}) => {
  const uniqueIds = [...new Set(user_ids.filter((id) => id))];
  const { data: auth } = await supabase.auth.getUser();
  const currentUserId = auth?.user?.id;

  const org_id = await getCurrentOrgId(currentUserId);

  console.log("📤 [Dispatch] Current User ID executing this:", currentUserId);
  console.log("📤 [Dispatch] Unique IDs to notify:", uniqueIds);

  const notifications = uniqueIds
    .filter((id) => id !== currentUserId) // Don't notify yourself
    .map((id) => ({
      org_id,
      to_user: id,
      from_user: currentUserId,
      subject,
      body,
      type: "direct",
      article_id,
      project_id,
      status: "unread",
    }));

  console.log("📤 [Dispatch] Final Payload being sent to DB:", notifications);

  if (notifications.length === 0) {
    return console.log(
      "📤 [Dispatch] ABORT: Payload is empty (everyone was filtered out)."
    );
  }

  const { data, error } = await supabase
    .from("messages")
    .insert(notifications)
    .select();

  if (error) {
    console.error("📤 [Dispatch] DB INSERT FAILED:", error);
  } else {
    console.log("📤 [Dispatch] SUCCESS! Messages created:", data);
  }
};

/**
 * 📧 OPTIONAL: External Email Trigger
 * Calls a Supabase Edge Function to send actual emails (via Resend, SendGrid, etc.)
 */
const triggerEmailAlerts = async (userIds, subject, body) => {
  try {
    // 1. Get the actual email addresses for these user IDs
    const { data: users } = await supabase
      .from("Users")
      .select("email")
      .in("id", userIds);

    if (!users || users.length === 0) return;

    const emailList = users.map((u) => u.email);

    // 2. Invoke a Supabase Edge function
    // (You would need to create this function in your Supabase dashboard)
    const { error } = await supabase.functions.invoke("send-email-alert", {
      body: {
        to: emailList,
        subject: subject,
        html_body: `<p>${body}</p><p><a href="https://yourportal.com">Log in to view</a></p>`,
      },
    });

    if (error) console.error("Edge function email error:", error);
  } catch (err) {
    console.error("Failed to trigger email alerts:", err);
  }
};
